// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as BildirislerRouteImport } from './routes/bildirisler'
import { Route as ElanlarRouteImport } from './routes/elanlar'
import { Route as ElaqeRouteImport } from './routes/elaqe'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as GirisRouteImport } from './routes/giris'
import { Route as HaqqimizdaRouteImport } from './routes/haqqimizda'
import { Route as HerracRouteImport } from './routes/herrac'
import { Route as IsElanlariRouteImport } from './routes/is-elanlari'
import { Route as KateqoriyalarRouteImport } from './routes/kateqoriyalar'
import { Route as MagazalarRouteImport } from './routes/magazalar'
import { Route as MesajlarRouteImport } from './routes/mesajlar'
import { Route as MexfilikRouteImport } from './routes/mexfilik'
import { Route as QeydiyyatRouteImport } from './routes/qeydiyyat'
import { Route as ReklamRouteImport } from './routes/reklam'
import { Route as SecilmislerRouteImport } from './routes/secilmisler'
import { Route as SertlerRouteImport } from './routes/sertler'
import { Route as SifreUnutdumRouteImport } from './routes/sifre-unutdum'
import { Route as SifreYenileRouteImport } from './routes/sifre-yenile'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedBalansRouteImport } from './routes/_authenticated/balans'
import { Route as AuthenticatedMagazamRouteImport } from './routes/_authenticated/magazam'
import { Route as AuthenticatedProfilRouteImport } from './routes/_authenticated/profil'
import { Route as AuthenticatedStatistikaRouteImport } from './routes/_authenticated/statistika'
import { Route as AuthenticatedYeniElanRouteImport } from './routes/_authenticated/yeni-elan'
import { Route as ElanIdRouteImport } from './routes/elan.$id'
import { Route as IstifadeciIdRouteImport } from './routes/istifadeci.$id'
import { Route as KateqoriyaSlugRouteImport } from './routes/kateqoriya.$slug'
import { Route as MagazaSlugRouteImport } from './routes/magaza.$slug'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin.index'
import { Route as AuthenticatedAdminAuditRouteImport } from './routes/_authenticated/admin.audit'
import { Route as AuthenticatedAdminAyarlarRouteImport } from './routes/_authenticated/admin.ayarlar'
import { Route as AuthenticatedAdminBannerlerRouteImport } from './routes/_authenticated/admin.bannerler'
import { Route as AuthenticatedAdminBildirislerRouteImport } from './routes/_authenticated/admin.bildirisler'
import { Route as AuthenticatedAdminBrendlerRouteImport } from './routes/_authenticated/admin.brendler'
import { Route as AuthenticatedAdminElanlarRouteImport } from './routes/_authenticated/admin.elanlar'
import { Route as AuthenticatedAdminHerraclarRouteImport } from './routes/_authenticated/admin.herraclar'
import { Route as AuthenticatedAdminIstifadecilerRouteImport } from './routes/_authenticated/admin.istifadeciler'
import { Route as AuthenticatedAdminKateqoriyalarRouteImport } from './routes/_authenticated/admin.kateqoriyalar'
import { Route as AuthenticatedAdminMagazaTesdiqleriRouteImport } from './routes/_authenticated/admin.magaza-tesdiqleri'
import { Route as AuthenticatedAdminMagazalarRouteImport } from './routes/_authenticated/admin.magazalar'
import { Route as AuthenticatedAdminMesajlarRouteImport } from './routes/_authenticated/admin.mesajlar'
import { Route as AuthenticatedAdminMuracietlerRouteImport } from './routes/_authenticated/admin.muracietler'
import { Route as AuthenticatedAdminOdenisSorgulariRouteImport } from './routes/_authenticated/admin.odenis-sorgulari'
import { Route as AuthenticatedAdminOdenislerRouteImport } from './routes/_authenticated/admin.odenisler'
import { Route as AuthenticatedAdminPaylasmaRouteImport } from './routes/_authenticated/admin.paylasma'
import { Route as AuthenticatedAdminPromokodlarRouteImport } from './routes/_authenticated/admin.promokodlar'
import { Route as AuthenticatedAdminPwaRouteImport } from './routes/_authenticated/admin.pwa'
import { Route as AuthenticatedAdminReylerRouteImport } from './routes/_authenticated/admin.reyler'
import { Route as AuthenticatedAdminRollarRouteImport } from './routes/_authenticated/admin.rollar'
import { Route as AuthenticatedAdminSeherlerRouteImport } from './routes/_authenticated/admin.seherler'
import { Route as AuthenticatedAdminSeoRouteImport } from './routes/_authenticated/admin.seo'
import { Route as AuthenticatedAdminSifarislerRouteImport } from './routes/_authenticated/admin.sifarisler'
import { Route as AuthenticatedAdminSikayetlerRouteImport } from './routes/_authenticated/admin.sikayetler'
import { Route as AuthenticatedAdminXetalarRouteImport } from './routes/_authenticated/admin.xetalar'
import { Route as AuthenticatedAdminZiyaretcilerRouteImport } from './routes/_authenticated/admin.ziyaretciler'
import { Route as AuthenticatedElanIdareIdRouteImport } from './routes/_authenticated/elan-idare.$id'
import { Route as AuthenticatedElanRedakteIdRouteImport } from './routes/_authenticated/elan-redakte.$id'
import { Route as AuthenticatedElanReklamIdRouteImport } from './routes/_authenticated/elan-reklam.$id'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const BildirislerRoute = BildirislerRouteImport.update({
            id: '/bildirisler',path: '/bildirisler',getParentRoute: () => rootRouteImport
          })
const ElanlarRoute = ElanlarRouteImport.update({
            id: '/elanlar',path: '/elanlar',getParentRoute: () => rootRouteImport
          })
const ElaqeRoute = ElaqeRouteImport.update({
            id: '/elaqe',path: '/elaqe',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const GirisRoute = GirisRouteImport.update({
            id: '/giris',path: '/giris',getParentRoute: () => rootRouteImport
          })
const HaqqimizdaRoute = HaqqimizdaRouteImport.update({
            id: '/haqqimizda',path: '/haqqimizda',getParentRoute: () => rootRouteImport
          })
const HerracRoute = HerracRouteImport.update({
            id: '/herrac',path: '/herrac',getParentRoute: () => rootRouteImport
          })
const IsElanlariRoute = IsElanlariRouteImport.update({
            id: '/is-elanlari',path: '/is-elanlari',getParentRoute: () => rootRouteImport
          })
const KateqoriyalarRoute = KateqoriyalarRouteImport.update({
            id: '/kateqoriyalar',path: '/kateqoriyalar',getParentRoute: () => rootRouteImport
          })
const MagazalarRoute = MagazalarRouteImport.update({
            id: '/magazalar',path: '/magazalar',getParentRoute: () => rootRouteImport
          })
const MesajlarRoute = MesajlarRouteImport.update({
            id: '/mesajlar',path: '/mesajlar',getParentRoute: () => rootRouteImport
          })
const MexfilikRoute = MexfilikRouteImport.update({
            id: '/mexfilik',path: '/mexfilik',getParentRoute: () => rootRouteImport
          })
const QeydiyyatRoute = QeydiyyatRouteImport.update({
            id: '/qeydiyyat',path: '/qeydiyyat',getParentRoute: () => rootRouteImport
          })
const ReklamRoute = ReklamRouteImport.update({
            id: '/reklam',path: '/reklam',getParentRoute: () => rootRouteImport
          })
const SecilmislerRoute = SecilmislerRouteImport.update({
            id: '/secilmisler',path: '/secilmisler',getParentRoute: () => rootRouteImport
          })
const SertlerRoute = SertlerRouteImport.update({
            id: '/sertler',path: '/sertler',getParentRoute: () => rootRouteImport
          })
const SifreUnutdumRoute = SifreUnutdumRouteImport.update({
            id: '/sifre-unutdum',path: '/sifre-unutdum',getParentRoute: () => rootRouteImport
          })
const SifreYenileRoute = SifreYenileRouteImport.update({
            id: '/sifre-yenile',path: '/sifre-yenile',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedBalansRoute = AuthenticatedBalansRouteImport.update({
            id: '/balans',path: '/balans',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedMagazamRoute = AuthenticatedMagazamRouteImport.update({
            id: '/magazam',path: '/magazam',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedProfilRoute = AuthenticatedProfilRouteImport.update({
            id: '/profil',path: '/profil',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedStatistikaRoute = AuthenticatedStatistikaRouteImport.update({
            id: '/statistika',path: '/statistika',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedYeniElanRoute = AuthenticatedYeniElanRouteImport.update({
            id: '/yeni-elan',path: '/yeni-elan',getParentRoute: () => AuthenticatedRouteRoute
          })
const ElanIdRoute = ElanIdRouteImport.update({
            id: '/elan/$id',path: '/elan/$id',getParentRoute: () => rootRouteImport
          })
const IstifadeciIdRoute = IstifadeciIdRouteImport.update({
            id: '/istifadeci/$id',path: '/istifadeci/$id',getParentRoute: () => rootRouteImport
          })
const KateqoriyaSlugRoute = KateqoriyaSlugRouteImport.update({
            id: '/kateqoriya/$slug',path: '/kateqoriya/$slug',getParentRoute: () => rootRouteImport
          })
const MagazaSlugRoute = MagazaSlugRouteImport.update({
            id: '/magaza/$slug',path: '/magaza/$slug',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminAuditRoute = AuthenticatedAdminAuditRouteImport.update({
            id: '/audit',path: '/audit',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminAyarlarRoute = AuthenticatedAdminAyarlarRouteImport.update({
            id: '/ayarlar',path: '/ayarlar',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminBannerlerRoute = AuthenticatedAdminBannerlerRouteImport.update({
            id: '/bannerler',path: '/bannerler',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminBildirislerRoute = AuthenticatedAdminBildirislerRouteImport.update({
            id: '/bildirisler',path: '/bildirisler',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminBrendlerRoute = AuthenticatedAdminBrendlerRouteImport.update({
            id: '/brendler',path: '/brendler',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminElanlarRoute = AuthenticatedAdminElanlarRouteImport.update({
            id: '/elanlar',path: '/elanlar',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminHerraclarRoute = AuthenticatedAdminHerraclarRouteImport.update({
            id: '/herraclar',path: '/herraclar',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminIstifadecilerRoute = AuthenticatedAdminIstifadecilerRouteImport.update({
            id: '/istifadeciler',path: '/istifadeciler',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminKateqoriyalarRoute = AuthenticatedAdminKateqoriyalarRouteImport.update({
            id: '/kateqoriyalar',path: '/kateqoriyalar',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminMagazaTesdiqleriRoute = AuthenticatedAdminMagazaTesdiqleriRouteImport.update({
            id: '/magaza-tesdiqleri',path: '/magaza-tesdiqleri',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminMagazalarRoute = AuthenticatedAdminMagazalarRouteImport.update({
            id: '/magazalar',path: '/magazalar',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminMesajlarRoute = AuthenticatedAdminMesajlarRouteImport.update({
            id: '/mesajlar',path: '/mesajlar',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminMuracietlerRoute = AuthenticatedAdminMuracietlerRouteImport.update({
            id: '/muracietler',path: '/muracietler',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminOdenisSorgulariRoute = AuthenticatedAdminOdenisSorgulariRouteImport.update({
            id: '/odenis-sorgulari',path: '/odenis-sorgulari',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminOdenislerRoute = AuthenticatedAdminOdenislerRouteImport.update({
            id: '/odenisler',path: '/odenisler',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminPaylasmaRoute = AuthenticatedAdminPaylasmaRouteImport.update({
            id: '/paylasma',path: '/paylasma',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminPromokodlarRoute = AuthenticatedAdminPromokodlarRouteImport.update({
            id: '/promokodlar',path: '/promokodlar',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminPwaRoute = AuthenticatedAdminPwaRouteImport.update({
            id: '/pwa',path: '/pwa',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminReylerRoute = AuthenticatedAdminReylerRouteImport.update({
            id: '/reyler',path: '/reyler',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminRollarRoute = AuthenticatedAdminRollarRouteImport.update({
            id: '/rollar',path: '/rollar',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSeherlerRoute = AuthenticatedAdminSeherlerRouteImport.update({
            id: '/seherler',path: '/seherler',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSeoRoute = AuthenticatedAdminSeoRouteImport.update({
            id: '/seo',path: '/seo',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSifarislerRoute = AuthenticatedAdminSifarislerRouteImport.update({
            id: '/sifarisler',path: '/sifarisler',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSikayetlerRoute = AuthenticatedAdminSikayetlerRouteImport.update({
            id: '/sikayetler',path: '/sikayetler',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminXetalarRoute = AuthenticatedAdminXetalarRouteImport.update({
            id: '/xetalar',path: '/xetalar',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminZiyaretcilerRoute = AuthenticatedAdminZiyaretcilerRouteImport.update({
            id: '/ziyaretciler',path: '/ziyaretciler',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedElanIdareIdRoute = AuthenticatedElanIdareIdRouteImport.update({
            id: '/elan-idare/$id',path: '/elan-idare/$id',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedElanRedakteIdRoute = AuthenticatedElanRedakteIdRouteImport.update({
            id: '/elan-redakte/$id',path: '/elan-redakte/$id',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedElanReklamIdRoute = AuthenticatedElanReklamIdRouteImport.update({
            id: '/elan-reklam/$id',path: '/elan-reklam/$id',getParentRoute: () => AuthenticatedRouteRoute
          })





const AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminAuditRoute: AuthenticatedAdminAuditRoute,AuthenticatedAdminAyarlarRoute: AuthenticatedAdminAyarlarRoute,AuthenticatedAdminBannerlerRoute: AuthenticatedAdminBannerlerRoute,AuthenticatedAdminBildirislerRoute: AuthenticatedAdminBildirislerRoute,AuthenticatedAdminBrendlerRoute: AuthenticatedAdminBrendlerRoute,AuthenticatedAdminElanlarRoute: AuthenticatedAdminElanlarRoute,AuthenticatedAdminHerraclarRoute: AuthenticatedAdminHerraclarRoute,AuthenticatedAdminIstifadecilerRoute: AuthenticatedAdminIstifadecilerRoute,AuthenticatedAdminKateqoriyalarRoute: AuthenticatedAdminKateqoriyalarRoute,AuthenticatedAdminMagazaTesdiqleriRoute: AuthenticatedAdminMagazaTesdiqleriRoute,AuthenticatedAdminMagazalarRoute: AuthenticatedAdminMagazalarRoute,AuthenticatedAdminMesajlarRoute: AuthenticatedAdminMesajlarRoute,AuthenticatedAdminMuracietlerRoute: AuthenticatedAdminMuracietlerRoute,AuthenticatedAdminOdenisSorgulariRoute: AuthenticatedAdminOdenisSorgulariRoute,AuthenticatedAdminOdenislerRoute: AuthenticatedAdminOdenislerRoute,AuthenticatedAdminPaylasmaRoute: AuthenticatedAdminPaylasmaRoute,AuthenticatedAdminPromokodlarRoute: AuthenticatedAdminPromokodlarRoute,AuthenticatedAdminPwaRoute: AuthenticatedAdminPwaRoute,AuthenticatedAdminReylerRoute: AuthenticatedAdminReylerRoute,AuthenticatedAdminRollarRoute: AuthenticatedAdminRollarRoute,AuthenticatedAdminSeherlerRoute: AuthenticatedAdminSeherlerRoute,AuthenticatedAdminSeoRoute: AuthenticatedAdminSeoRoute,AuthenticatedAdminSifarislerRoute: AuthenticatedAdminSifarislerRoute,AuthenticatedAdminSikayetlerRoute: AuthenticatedAdminSikayetlerRoute,AuthenticatedAdminXetalarRoute: AuthenticatedAdminXetalarRoute,AuthenticatedAdminZiyaretcilerRoute: AuthenticatedAdminZiyaretcilerRoute,AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute
}

const AuthenticatedAdminRouteWithChildren = AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,AuthenticatedBalansRoute: AuthenticatedBalansRoute,AuthenticatedMagazamRoute: AuthenticatedMagazamRoute,AuthenticatedProfilRoute: AuthenticatedProfilRoute,AuthenticatedStatistikaRoute: AuthenticatedStatistikaRoute,AuthenticatedYeniElanRoute: AuthenticatedYeniElanRoute,AuthenticatedElanIdareIdRoute: AuthenticatedElanIdareIdRoute,AuthenticatedElanRedakteIdRoute: AuthenticatedElanRedakteIdRoute,AuthenticatedElanReklamIdRoute: AuthenticatedElanReklamIdRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,BildirislerRoute: BildirislerRoute,ElanlarRoute: ElanlarRoute,ElaqeRoute: ElaqeRoute,FaqRoute: FaqRoute,GirisRoute: GirisRoute,HaqqimizdaRoute: HaqqimizdaRoute,HerracRoute: HerracRoute,IsElanlariRoute: IsElanlariRoute,KateqoriyalarRoute: KateqoriyalarRoute,MagazalarRoute: MagazalarRoute,MesajlarRoute: MesajlarRoute,MexfilikRoute: MexfilikRoute,QeydiyyatRoute: QeydiyyatRoute,ReklamRoute: ReklamRoute,SecilmislerRoute: SecilmislerRoute,SertlerRoute: SertlerRoute,SifreUnutdumRoute: SifreUnutdumRoute,SifreYenileRoute: SifreYenileRoute,ElanIdRoute: ElanIdRoute,IstifadeciIdRoute: IstifadeciIdRoute,KateqoriyaSlugRoute: KateqoriyaSlugRoute,MagazaSlugRoute: MagazaSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)